<!-- Order preview table component -->
<template>
	<div class="card">
		<div class="card-body">
			<div class="table-responsive mb-0">
				<table
					class="table table-centered table-nowrap table-hover mb-0 mt-2"
				>
					<thead>
						<tr>
							<th>
								{{ $t('Place Order.table_header_clientref') }}
							</th>
							<th>
								{{
									$t(
										'Place Order.table_header_pickup_address'
									)
								}}
							</th>
							<th>
								{{ $t('Place Order.table_header_pickup_time') }}
							</th>
							<th>{{ $t('Place Order.table_header_sender') }}</th>
							<th>
								{{
									$t(
										'Place Order.table_header_dropoff_address'
									)
								}}
							</th>
							<th>{{ $t('Place Order.table_header_sla') }}</th>
							<th>
								{{ $t('Place Order.table_header_recipient') }}
							</th>
							<th>
								{{
									$t('Place Order.table_header_number_parcel')
								}}
							</th>
							<th>{{ $t('Place Order.table_header_weight') }}</th>
							<th>
								{{ $t('Place Order.table_header_remarks') }}
							</th>
							<th>{{ $t('Place Order.table_header_tags') }}</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="(item, index) of list">
							<tr :key="index">
								<td>
									<template
										v-for="(
											clientRef, i
										) of item.clientRefs"
									>
										<h5
											:key="i"
											class="font-14 mb-1 font-weight-normal"
										>
											{{ clientRef.value }}
										</h5>
									</template>
								</td>
								<td>
									<h5 class="font-14 mb-1 font-weight-normal">
										{{ item.pickupAddress }}
									</h5>
								</td>
								<td>
									<h5 class="font-14 mb-1 font-weight-normal">
										{{
											displayDatetime(
												item.pickupAt,
												$t('Datetime.time_24')
											)
										}}
									</h5>
									<h5 class="font-14 mb-1 font-weight-normal">
										{{
											displayDatetime(
												item.pickupAt,
												$t('Datetime.date_full')
											)
										}}
									</h5>
								</td>
								<td>
									<template
										v-for="(
											contact, i
										) of item.pickupContacts"
									>
										<h5
											:key="`${i}${contact.name}`"
											class="font-14 mb-1 font-weight-normal"
										>
											{{ contact.name }}
										</h5>
										<h5
											:key="`${i}${contact.phone}`"
											class="font-14 mb-1 font-weight-normal"
										>
											{{ contact.phone }}
										</h5>
									</template>
									<template
										v-if="!item.pickupContacts.length"
									>
										N/A
									</template>
								</td>
								<td>
									<h5 class="font-14 mb-1 font-weight-normal">
										{{ item.dropoffAddress }}
									</h5>
								</td>
								<td>
									<h5 class="font-14 mb-1 font-weight-normal">
										{{
											displayDatetime(
												item.deliveryBy,
												$t('Datetime.time_24')
											)
										}}
									</h5>
									<h5 class="font-14 mb-1 font-weight-normal">
										{{
											displayDatetime(
												item.deliveryBy,
												$t('Datetime.date_full')
											)
										}}
									</h5>
								</td>
								<td>
									<template
										v-for="(
											contact, i
										) of item.dropoffContacts"
									>
										<h5
											:key="`${i}${contact.name}`"
											class="font-14 mb-1 font-weight-normal"
										>
											{{ contact.name }}
										</h5>
										<h5
											:key="`${i}${contact.phone}`"
											class="font-14 mb-1 font-weight-normal"
										>
											{{ contact.phone }}
										</h5>
									</template>
									<template
										v-if="!item.dropoffContacts.length"
									>
										N/A
									</template>
								</td>
								<td>
									<h5 class="font-14 mb-1 font-weight-normal">
										{{ item.parcelNum }}
									</h5>
								</td>
								<td>
									<h5 class="font-14 mb-1 font-weight-normal">
										{{ item.totalWeight || 'N/A' }}
									</h5>
								</td>
								<td>
									<template
										v-for="(note, i) of item.notes || []"
									>
										<h5
											:key="i"
											class="font-14 mb-1 font-weight-normal"
										>
											{{ note }}
										</h5>
									</template>
								</td>
								<td>
									<template v-for="(tag, i) of item.tags">
										<h5
											:key="i"
											class="font-14 mb-1 font-weight-normal"
										>
											{{ tag.key }}: {{ tag.value }}
										</h5>
									</template>
									<template v-if="!item.tags.length">
										N/A
									</template>
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { displayDatetime } from '@/utils/helpers'

export default {
	props: {
		list: {
			type: Array,
			required: false,
			default: () => []
		}
	},
	methods: {
		displayDatetime
	}
}
</script>

<style scoped></style>
